import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const exportQuoteSearchSchema = z.object({
  exportTechnicalQuote: z.boolean().optional(),
});

export const exportQuoteSearchSchemaValidator = zodValidator(exportQuoteSearchSchema);
